import { useState } from "react";
import type { Match } from "@/types";

interface LiveDemoProps {
  match: Match;
}

export default function LiveDemo({ match }: LiveDemoProps) {
  const [notice, setNotice] = useState(false);
  const isLive = match.status === "live";

  const handlePlay = () => {
    setNotice(true);
    window.setTimeout(() => setNotice(false), 3200);
  };

  return (
    <div className="bg-background-50 rounded-lg border border-background-200 overflow-hidden">
      <div className="flex items-center justify-between px-4 py-3 border-b border-background-200">
        <h2 className="font-heading text-base font-bold text-foreground-950 flex items-center gap-2">
          <i className="ri-live-line text-accent-500"></i> 比赛直播
        </h2>
        <span className="text-xs text-foreground-400 font-label">演示区域</span>
      </div>

      <div className="relative aspect-video bg-primary-950 overflow-hidden">
        <div className="absolute inset-0 opacity-40 bg-[radial-gradient(circle_at_30%_30%,oklch(var(--primary-700)),transparent_60%),radial-gradient(circle_at_75%_75%,oklch(var(--accent-800)),transparent_60%)]"></div>
        <div className="relative w-full h-full flex flex-col items-center justify-center text-center px-4">
          <span className="w-16 h-16 rounded-full bg-background-50/10 border border-background-50/20 text-background-50 flex items-center justify-center text-3xl mb-4">
            <i className="ri-basketball-line"></i>
          </span>
          <p className="font-heading text-xl md:text-2xl font-bold text-background-50">直播演示区</p>
          <p className="mt-2 text-xs md:text-sm text-primary-300 max-w-md leading-relaxed">
            当前区域为前端演示界面，暂未接入真实直播信号。点击下方按钮可体验播放交互演示。
          </p>
          {isLive && (
            <span className="mt-4 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-accent-500 text-accent-950 text-xs font-label font-semibold">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-950 animate-pulse-dot"></span> 比赛中
            </span>
          )}
        </div>

        {notice && (
          <div className="absolute top-4 left-1/2 -translate-x-1/2 px-4 py-2 rounded-md bg-background-50/95 text-foreground-900 text-xs font-medium shadow-sm flex items-center gap-2 animate-fade-up">
            <i className="ri-information-line text-accent-600"></i> 当前为演示界面，暂未接入真实直播信号
          </div>
        )}

        <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4 bg-gradient-to-t from-primary-950 to-transparent">
          <div className="flex items-center gap-3">
            <button
              type="button"
              onClick={handlePlay}
              aria-label="播放"
              className="w-10 h-10 rounded-full bg-accent-500 text-accent-950 flex items-center justify-center text-xl hover:bg-accent-400 transition-colors cursor-pointer shrink-0"
            >
              <i className="ri-play-fill"></i>
            </button>
            <div className="flex-1 h-1.5 rounded-full bg-background-50/20 overflow-hidden">
              <div className="h-full w-1/3 rounded-full bg-accent-500"></div>
            </div>
            <span className="text-xs text-background-50/80 font-label whitespace-nowrap">演示 · 00:00</span>
            <div className="hidden sm:flex items-center gap-2 text-background-50/80 text-lg">
              <i className="ri-volume-up-line cursor-pointer hover:text-background-50"></i>
              <i className="ri-fullscreen-line cursor-pointer hover:text-background-50"></i>
            </div>
          </div>
        </div>
      </div>

      <div className="px-4 py-3 bg-accent-50 border-t border-accent-100 flex items-start gap-2">
        <i className="ri-alert-line text-accent-600 mt-0.5"></i>
        <p className="text-xs text-accent-900 leading-relaxed">
          温馨提示：本站直播区域仅作前端演示，不提供真实直播信号，展示内容与数据均为模拟示范，请勿据此判断实际比赛结果。
        </p>
      </div>
    </div>
  );
}